import { Container, Row, Col } from 'react-bootstrap';
import Helmet from 'react-helmet';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaWhatsapp, FaFacebook, FaInstagram, FaVk, FaTwitter, FaTelegram } from 'react-icons/fa';

const Contact = () => {
    return (
        <Container fluid>
            <Helmet>
                <meta charset="UTF-8" />
                <title>ТОО "СИНОМОСТ" - контакты, номера, адрес.</title>
                <meta name="description" content="Спецтехника и автомобили. Фронтальные погразчики, самосвалы, краны, бульдозеры, экскаваторы, асфальтоукладчики, рейдеры. Кроссоверы, Седаны, Внедорожники." />
                <meta name="keywords" content="BAIC, Beijing, Senovo, Liugong, Lonking, Фронтальные погразчики, самосвалы, краны, бульдозеры, экскаваторы, асфальтоукладчики, рейдеры. Кроссоверы, Седаны, Внедорожники" />
            </Helmet>
            <Row className="pt-5">
                <Col className="" sm={12} lg={12}>
                    <h1>Контакты</h1>
                    <FaMapMarkerAlt /> Адрес: РК, г. Алматы, Микрорайон Мадениет, 171<br />
                    <FaPhone /> Телефоны: <a href="tel:+77015471529">+7&nbsp;701&nbsp;547-1529</a> <br />
                    <FaWhatsapp /> Whatsapp: <a href="https://wa.me/77015471529">+7&nbsp;701&nbsp;547-1529</a> <br />
                    <FaEnvelope /> Почта: info@sinomost.kz <br />
                    <hr />
                    Соц. сети: <br />
                    <a href="https://facebook.com/sinomost.kz"><FaFacebook /></a> <a href="https://instagram.com/sinomost_official"><FaInstagram /></a> <a href="https://vk.com/sinomost"><FaVk /></a> <a href="https://twitter.com/sinomost"><FaTwitter /></a> <a href="https://t.me/sinomost"><FaTelegram /></a>
                </Col>
                <div className="w-100 p-0 m-0 mt-3"><div style={{ position: 'relative', overflow: 'hidden'}}><a href="https://yandex.kz/maps/162/almaty/?utm_medium=mapframe&utm_source=maps" style={{ color: '#eee', position: 'absolute', top: '0px'}}>Алматы</a><a href="https://yandex.kz/maps/162/almaty/?ll=76.831091%2C43.348340&utm_medium=mapframe&utm_source=maps&z=17" style={{color: '#eee', position: 'absolute', top: '14px'}}>Алматы — Яндекс Карты</a><iframe src="https://yandex.kz/map-widget/v1/?ll=76.831091%2C43.348340&z=17" width="100%" height="400" frameborder="1" allowfullscreen="true" style={{position: 'relative'}}></iframe></div></div>
            </Row>
        </Container>
    );
};

export default Contact;
